// PrivateShowTicketNotice.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { withTranslation } from 'react-i18next';

import LiveStreamUserAvatar from '../container/LiveStreamUserAvatar.js';

import { textColor } from '../style/variables.js';
import TextEllipsis from '../style/TextEllipsis.js';
import UserLevelBadge from '../container/UserLevelBadge.js';
import UserLivestreamBadges from '../container/UserLivestreamBadges.js';
import TicketIconSource from '../../img/ic_ticket_xl.svg';
import { UserBadge } from '../component/UserLivestreamBadges.jsx';

export class PrivateShowTicketNotice extends React.PureComponent {
  fetchUser = () => {
    const {
      userId,
      username,
      fetchUser,
      displayName,
      isUserFetching,
      isUserFetched,
    } = this.props;
    if (
      userId &&
      (!username || (!displayName && !isUserFetching && !isUserFetched))
    ) {
      return fetchUser({ userId });
    }
    return;
  };
  componentDidMount() {
    this.fetchUser();
  }
  componentDidUpdate(prevProps) {
    const { userId } = this.props;
    if (userId !== prevProps.userId) {
      this.fetchUser();
    }
  }
  render() {
    const {
      streamId,
      userId,
      username,
      displayName,
      isDisplayNameEnabled,
      noticeStatus,
      amount,
      senderLevel,
      senderBadges,
    } = this.props;
    return (
      <StyledPrivateShowTicketNotice status={noticeStatus}>
        <PrivateShowTicketDetail>
          <TicketAvatarWrapper>
            <TicketIcon src={TicketIconSource} />
            <AvatarWrapper>
              <LiveStreamUserAvatar
                streamId={streamId}
                userId={userId}
                badgeSize={44}
                avatarSize={28}
                diamondSize={10}
                shouldDisplayMVP
              />
            </AvatarWrapper>
          </TicketAvatarWrapper>
          <TicketInformation>{`+${amount}`}</TicketInformation>
          <UserInfo>
            <UserLevelBadge level={senderLevel} />
            <DisplayName>
              {isDisplayNameEnabled && displayName ? displayName : ''}
              <Username>{username ? `@${username}` : '-'}</Username>
            </DisplayName>
            <UserLivestreamBadges badges={senderBadges} />
          </UserInfo>
          <PrivateShowMvpButtonPlaceholder />
        </PrivateShowTicketDetail>
      </StyledPrivateShowTicketNotice>
    );
  }
}

PrivateShowTicketNotice.propTypes = {
  streamId: PropTypes.string,
  userId: PropTypes.string,
  username: PropTypes.string,
  displayName: PropTypes.string,
  isDisplayNameEnabled: PropTypes.bool,
  isUserFetching: PropTypes.bool,
  isUserFetched: PropTypes.bool,
  noticeStatus: PropTypes.string,
  amount: PropTypes.number,
  senderLevel: PropTypes.number,
  senderBadges: PropTypes.array,
  fetchUser: PropTypes.func,
};

PrivateShowTicketNotice.defaultProps = {
  streamId: null,
  userId: null,
  username: '',
  displayName: '',
  isDisplayNameEnabled: true,
  isUserFetching: false,
  isUserFetched: false,
  noticeStatus: 'display',
  amount: 0,
  senderLevel: null,
  senderBadges: [],
  fetchUser: () => null,
};

const StyledPrivateShowTicketNotice = styled.div`
  background-color: #8238ba66;
`;

const PrivateShowTicketDetail = styled.div`
  display: flex;
  padding-left: 14px;
  padding-right: 8px;
  width: 100%;
  height: 28px;
  align-items: center;
  background-color: #8238ba66;
  ${({ status }) => {
    if (status === 'coming') {
      return css``;
    } else if (status === 'leaving') {
      return css`
        display: none;
      `;
    }
  }}
`;

const TicketAvatarWrapper = styled.div`
  flex: none;
  margin-right: 4px;
  position: relative;
  width: 42px;
  height: 42px;
`;

const AvatarWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const TicketIcon = styled.img`
  width: 100%;
  height: 100%;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  text-align: left;
  overflow: hidden;
  > ${UserBadge} {
    margin-left: 4px;
  }
`;

const Username = styled.span`
  ${TextEllipsis};
  margin-left: 2px;
  font-size: 14px;
  color: ${textColor.grey};
`;

const DisplayName = styled.span`
  ${TextEllipsis};
  margin-right: 4px;
  font-size: 14px;
  color: ${textColor.white};
  white-space: nowrap;
`;

const TicketInformation = styled.div`
  flex: none;
  display: flex;
  margin-right: 8px;
  font-size: 18px;
  font-weight: 600;
  color: ${textColor.white};
`;

const PrivateShowMvpButtonPlaceholder = styled.div``;

export default withTranslation()(PrivateShowTicketNotice);
